export const queryKeys = {
  getLookupValues: "getLookupValues",
  getLookupValue: "getLookupValue",
};
